import { render, staticRenderFns } from "./ExcelUpload.vue?vue&type=template&id=04b110b5&scoped=true"
import script from "./ExcelUpload.vue?vue&type=script&lang=js"
export * from "./ExcelUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b110b5",
  null
  
)

export default component.exports